import { post } from '@/util/crmAxios'
import { getBasicUrls } from '@/util/config'
const send = (name, data) => post(getBasicUrls().schoolm + 'manage/faceAgeAudit/' + name, data)
const api = {}
;['schools','page','detail','submit'].forEach(name => {
  api[name] = async (data = {}) => {
    const response = await send(name, data)
    if (!response || ![0, 200].includes(Number(response.code))) throw new Error(response && response.message || '人脸审核请求失败')
    return response.data
  }
})
export default api
